import React from 'react';
import { arrayOf, shape, string, number } from 'prop-types';
import classNames from 'classnames';
import css from './PriceRulesBadge.module.css';

/**
 * PriceRulesBadge — shows which price rules are active for the current booking.
 *
 * Usage (in OrderPanel after price display):
 *   <PriceRulesBadge appliedRules={appliedRules} />
 *
 * @param {Object[]} props.appliedRules — from applyPriceRules().appliedRules
 */
const RULE_LABELS = {
  weekend: '🏖 Weekend rate',
  lastMinute: '⚡ Last minute deal',
  season: '☀️ Peak season',
  custom: '📅 Special pricing',
};

const PriceRulesBadge = ({ appliedRules, className }) => {
  if (!appliedRules || appliedRules.length === 0) return null;

  return (
    <div className={classNames(css.root, className)}>
      {appliedRules.map((rule, i) => {
        const label = RULE_LABELS[rule.type] || 'Price rule applied';
        const sign = rule.adjust > 0 ? '+' : '';
        const adjustment =
          rule.unit === 'percent'
            ? `${sign}${rule.adjust}%`
            : `${sign}${rule.adjust / 100}`;

        return (
          <span key={i} className={css.badge}>
            {label} ({adjustment})
          </span>
        );
      })}
    </div>
  );
};

PriceRulesBadge.defaultProps = { appliedRules: [], className: null };
PriceRulesBadge.propTypes = {
  appliedRules: arrayOf(shape({ type: string, adjust: number, unit: string })),
  className: string,
};

export default PriceRulesBadge;
